import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import SubscriptionForm from '@components/SubscriptionForm';
import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { User } from '@utils/backend-api/currentUser';
import { SelectedOffer } from '@utils/backend-api/subscribe';
import { LeadTypes } from '@utils/enums';

import PlanOptions from './PlanOptions';

interface ReferralSubscriptionProps {
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  referralOffer: SelectedOffer;
  referringSubGuid: string;
  referringSubName: string;
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
}
const queryClient = new QueryClient();

const Subscription = ({
  initialCurrentUser,
  isGdprRequired,
  referralOffer,
  referringSubGuid,
  referringSubName,
  stripeCustomerId,
  userEmail,
  userFullName,
}: ReferralSubscriptionProps) => {
  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprRequired}>
      <SubscribeFormProvider user={{ email: userEmail, name: userFullName, stripeCustomerId }}>
        <QueryClientProvider client={queryClient}>
          <PlanOptions referralOffer={referralOffer} referringSubName={referringSubName} />
          <div className="mx-auto w-full px-12 sm:w-8/12 lg:w-6/12">
            <SubscriptionForm
              formLocation="referral_subscribe"
              buttonText="Subscribe"
              leadType={LeadTypes.ReferralPage}
              presentedOfferCodes={[referralOffer.code]}
              referringSubscriberGuid={referringSubGuid}
              referringSubscriberName={referringSubName}
              selectedOffer={referralOffer}
            />
          </div>
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default Subscription;
